import React, { useEffect, useState } from 'react';
import { useNavigation } from '../contexts/NavigationContext';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const TabContainer = styled.div`
  display: flex;
  flex-direction:column;
  width:auto;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 30px;
    margin: auto;
    display: block;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index:1;
    background-color:var(--primary-color);
  }

`;

const Tab = styled.div`
  padding: 10px;
  margin: 10px 15px;
  cursor: pointer;
  border: solid 0.5px rgba(255, 255, 255, 0.15);
  border-radius:5px;
  color: ${(props) => (props.$active === "true" ? 'var(--font-on-secondary-color)' : 'var(--font-on-primary-color)')};
  font-weight: ${(props) => (props.$active === "true" ? '600' : '400')};
  background-color: ${(props) => (props.$active === "true" ? 'var(--secondary-color)' : 'transparent')};
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.4); 
  transition: box-shadow 0.3s ease; 
  &:hover {
    background-color: ${(props) => (props.$active === "true" ?'var(--secondary-color)' : 'var(--primary-hover-color)')}; 
  }
  @media (max-width: 1000px) {
    width: 80%;
    padding: 8px;
    margin: 8px auto;
  }


`;
const MenuToggle = styled.button`
  display: none;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;

  @media (max-width: 1000px) {
    display: block;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index:2;
  }
`;
const Sidebar = styled.div`
  background-color:var(--primary-color);
  color:var(--font-on-primary-color);
  width:15%;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  @media (max-width: 100px) {
    flex-direction: row;
    width:100%;
 
  }
`;

const Navbar = () => {
  const { activePage, navigateTo } = useNavigation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleTabClick = (tabId) => {
    navigateTo(tabId);
    setIsMenuOpen(false);
  };
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <Sidebar>
      {location.pathname !== '/registroAsistencia' && (
        <>
          <MenuToggle onClick={toggleMenu}>
            {isMenuOpen ? '✖️' : '☰'}
          </MenuToggle>
          {(isMenuOpen || window.innerWidth >= 1000) && (
            <TabContainer>
              <Tab $active={(activePage === 'students') ? "true" : "false"} onClick={() => handleTabClick('students')}>Students</Tab>
              <Tab $active={(activePage === 'subjects') ? "true" : "false"} onClick={() => handleTabClick('subjects')}>Subjects</Tab>
              <Tab $active={(activePage === 'payments') ? "true" : "false"} onClick={() => handleTabClick('payments')}>Payments</Tab>
              <Tab $active={(activePage === 'attendance') ? "true" : "false"} onClick={() => handleTabClick('attendance')}>Attendance</Tab>
            </TabContainer>
          )}
        </>
      )}
    </Sidebar>
  );
};

export default Navbar;

